<template>
  <div class="about">
    <div class="container">
      <div class="row">
        <div class="col s12 m6">
          <div class="title">Me myself & I.</div>
          <p>My name is <span>Kennedy Baraka Konde</span>.</p>
          <p>
            I'm a Full Stack Developer based in Nairobi, Kenya. I have a serious
            passion in developing systems all the way from their elegant User
            Interfaces (UI) to their most crutial core functionality (Back-end).
          </p>

          <p>
            Well organised person, problem solver, interactive, chearful, ready
            to learn any time I get a chance to and one who focuses on details
            to bring out the best customer experience. Curently I am into
            freelancing as a developer and it has been the best experience not
            only to me but also to my cherished clients.
          </p>
          <p>
            I may say the love for technology is inborn and it runs in my DNA.
          </p>
          <router-link to="/socials" class="link"
            >You want something special made today?
          </router-link>
        </div>
        <div class="col s12 m6 my">
          <img
            src="@/assets/vectors/about1.svg"
            class="img-responsive swing"
            style="animation-delay: 2s"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.about {
  min-height: 100%;
  /* margin-top: auto; */
  align-items: center;
  justify-content: center;
  margin-top: 75px;
  margin-bottom: 75px;
}
.title {
  font-size: 48px;
  font-weight: 600;
}
.link {
  text-decoration: none;
  font-weight: 600;
  color: #765cd1;
  position: relative;
  display: inline-block;
  background: linear-gradient(to right, #765cd1, midnightblue 50%, #765cd1 50%);
  overflow: hidden;
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-size: 200% 100%;
  background-position: 100%;
  transition: background-position 275ms ease;
}
.link:hover {
  background-position: 0 100%;
}
.img-responsive {
  width: 100%;
  height: auto;
}
span {
  border-bottom: 2px dotted #765cd1;
  font-weight: 600;
}
@media only screen and (max-width: 601px) {
  .my {
    margin-top: 30px;
    margin-bottom: 30px;
  }
}
@-webkit-keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20py);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

@keyframes swinging {
  0% {
    /* -webkit-transform: (8deg); */
    -webkit-transform: translateY(20px);
  }
  50% {
    /* -webkit-transform: rotate(-4deg); */
    -webkit-transform: translateY(0px);
  }
  100% {
    /* -webkit-transform: rotate(8deg); */
    -webkit-transform: translateY(20px);
  }
}

.swing {
  -webkit-transform-origin: 50% 0;
  transform-origin: 50% 0;
  -webkit-animation: swinging 3.5s ease-in-out forwards infinite;
  animation: swinging 3.5s ease-in-out forwards infinite;
}

.grey {
  color: grey;
}
</style>
